import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import MyInfoComponent from "@/pages/user/UserAccountComponent/components/MyInfoComponent/MyInfoComponent";
import Loader from "@componentsShared/Loader/Loader";
import { useTranslation } from "@i18n";
import { api__getCitiesDropDown } from "@/apis/assets/api__get_cities_drop_down";
import useApi from "@hooks/useApi";
import { api__me } from "@/apis/customer/me";
var MyInfo = function MyInfo() {
  var _useTranslation = useTranslation(["web_user_account"]),
    t = _useTranslation.t;
  var _useApi = useApi([], api__getCitiesDropDown),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    cities = _useApi2[2];
  var _useApi3 = useApi([], api__me),
    _useApi4 = _slicedToArray(_useApi3, 3),
    loading2 = _useApi4[0],
    error2 = _useApi4[1],
    user_info = _useApi4[2];
  if (loading || loading2) return /*#__PURE__*/React.createElement(Loader, null);
  return /*#__PURE__*/React.createElement(Layout, {
    hideOrangeHeadBtn: true,
    hideAppBanner: true,
    headHideLinks: true,
    mobileHasTitle: t("my_information", {
      ns: "web_user_account"
    }),
    mobileHasBack: true,
    mobileNoLogo: true
  }, /*#__PURE__*/React.createElement(MyInfoComponent, {
    cities: cities
  }));
};
export default MyInfo;